import React, { useContext } from "react";
import { FaEye, FaExclamationCircle, FaRunning, FaFirstAid } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./worker3.jpg";

const SafetyAwareness: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/awareness');
    } else {
      navigate('/login', { state: { from: '/booking/awareness' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Core Module</span>
          <h1 className="hero-title">General Safety Awareness</h1>
          <p className="hero-subtitle">
            Building a foundation of vigilance. Recognizing hazards, understanding accident theory,
            and creating a culture where safety is everyone's responsibility.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Heinrich's Domino Theory</h2>
              <p className="article-text">
                Accidents don't happen in a vacuum. Heinrich's Law suggests that for every major injury,
                there are 29 minor injuries and 300 non-injury incidents (near misses).
                By addressing the base—unsafe acts and conditions—we prevent the dominos from falling
                toward a fatality.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Unsafe Acts vs. Conditions</h2>
              <p className="article-text">
                <strong>Unsafe Conditions</strong> are environmental hazards: wet floors, unguarded machines,
                or frayed wires. <strong>Unsafe Acts</strong> are human errors: running, bypassing guards,
                or horseplay. Effective safety awareness trains eyes to see both simultaneously.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Slips, Trips, and Falls</h2>
              <p className="article-text">
                These are the most common general industry accidents. Good housekeeping, proper lighting,
                and awareness of surroundings (no texting while walking!) can eliminate the majority
                of these incidents.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Emergency Preparedness</h2>
              <p className="article-text">
                Awareness means knowing what to do <em>before</em> the alarm sounds. Know your assembly point,
                know the nearest extinguisher location, and know the emergency contact numbers.
                Panic is the enemy of survival.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Focus Areas</h4>
              <ul className="key-list">
                <li><FaExclamationCircle className="check-icon" /> Hazard Recognition</li>
                <li><FaRunning className="check-icon" /> Slip/Trip Prevention</li>
                <li><FaEye className="check-icon" /> Visual Awareness</li>
                <li><FaFirstAid className="check-icon" /> Incident Reporting</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Train Your Team</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Build a safety-first culture from day one.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SafetyAwareness;
